import { css } from "./common";
import { getCssValue } from "./index";
export const absolutePosition = {
    top: css `
    top: ${(p) => getCssValue(p.top)};
  `,
    bottom: css `
    bottom: ${(p) => getCssValue(p.bottom)};
  `,
    left: css `
    left: ${(p) => getCssValue(p.left)};
  `,
    right: css `
    right: ${(p) => getCssValue(p.right)};
  `,
};
export const marginCss = {
    mt: css `
    margin-top: ${(p) => getCssValue(p.mt)};
  `,
    mb: css `
    margin-bottom: ${(p) => getCssValue(p.mb)};
  `,
    ml: css `
    margin-left: ${(p) => getCssValue(p.ml)};
  `,
    mr: css `
    margin-right: ${(p) => getCssValue(p.mr)};
  `,
    m: css `
    margin: ${(p) => getCssValue(p.m)};
  `,
};
export const paddingCss = {
    pt: css `
    padding-top: ${(p) => getCssValue(p.pt)};
  `,
    pb: css `
    padding-bottom: ${(p) => getCssValue(p.pb)};
  `,
    pl: css `
    padding-left: ${(p) => getCssValue(p.pl)};
  `,
    pr: css `
    padding-right: ${(p) => getCssValue(p.pr)};
  `,
    p: css `
    padding: ${(p) => getCssValue(p.p)};
  `,
};
//# sourceMappingURL=positionCss.js.map